export default "__VITE_ASSET__C0WWYkp2__"